import { render, staticRenderFns } from "./BoxQuery.vue?vue&type=template&id=8d53ea32&"
import script from "./BoxQuery.vue?vue&type=script&lang=js&"
export * from "./BoxQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports